import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  RendererFactory2,
  ElementRef,
  ViewChild
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ManageTeamsComponent } from '../manage-teams/manage-teams.component';
import { ManageSurveyPermissionsModalComponent } from '../manage-survey-permissions-modal/manage-survey-permissions-modal.component';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { Router } from '@angular/router';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { OrgUsersService } from '../../services/org-users.service';
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import {
  TrustMarketplaceStatusService
} from "../../../../services/trust-marketplace-status/trust-marketplace-status.service";

@Component({
  selector: 'app-new-invite-user',
  templateUrl: './new-invite-user.component.pug',
  styleUrls: ['./new-invite-user.component.scss'],
  standalone: false
})
export class NewInviteUserComponent implements OnInit {
  @Input() organisation = '';
  @Input() email = '';
  errors = [
    {
      name: 'wrongPattern',
      msg: $localize`A valid business email address is required, please review and edit to proceed.`,
      enabled: false,
    },
  ];
  @Input() memberOptions = ConstantsService.getMemberOptions();
  filteredMemberOptions :any;
  referenceOptions = [
    { key: 2, value: $localize`Administrator` },
    { key: 3, value: $localize`Requestor` },
    { key: 4, value: $localize`Contributor` },
    { key: 0, value: $localize`None` },
  ];
  dropDownOptions = [
    { key: 2, value: $localize`Administrator` },
    { key: 3, value: $localize`Requestor` },
    { key: 4, value: $localize`Contributor` },
    { key: 5, value: $localize`Analyst` },
    { key: 0, value: $localize`None` },
  ];
  integrationOptions = [
    { key: 1, value: $localize`Integration user` },
    { key: 0, value: $localize`None` },
  ];
  SUBTEXT = {
    'owner': $localize`Unrestricted access to all products, organisation settings, and user management.`,
    'member': $localize`Access to one or more products.`,
    'support': $localize`Invite Xref Support staff to help with your account or troubleshoot an issue.`,
  }

  @Input() selectedTeams: any = [];

  @Input() selectedSurveys: any = [];

  isValid: boolean = false;
  @Input() selectedRole = '';
  @Input() cloned = false;
  xrefEmail = false;
  canEditOwner = false;


  @Input() cloneData: any;
  @Output() saveClick: EventEmitter<any> = new EventEmitter();
  showTeamIndex = 0;
  showSurveyIndex = 0;
  model: any;
  disableAll: boolean= false;
  totalSurvey = 0;
  PERMISSION_BTN_TEXT = $localize`See permission details.`;

  teams: any = [];
  message = '';
  renderer: Renderer2;
  @ViewChild('inputElement', { read: ElementRef }) inputElement!: ElementRef;
  clicked = false;

  constructor(
    private modalService: BsModalService,
    private cdr: ChangeDetectorRef,
    public modalRef: BsModalRef,
    private permission: PermissionsService,
    private router: Router,
    private organisationService: OrganisationService,
    private rendererFactory: RendererFactory2,
    public orgUserService: OrgUsersService,
    private trustMarketplaceStatusService: TrustMarketplaceStatusService,
    private alertList: AlertBannerService,
    private permissions: PermissionsService,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  ngOnInit(): void {
    this.organisation = this.organisationService.organisationBrandName || '';
    const role: any = this.permission.role;
    this.canEditOwner = (role?.role === 'owner' || role?.role === 'support') && this.allProductUserPermissions();
    this.fetchTrustMarketplaceStatus();

    this.filteredMemberOptions = this.memberOptions.map(option => {
      return {
        ...option,
        display_name: $localize`${option?.display_name}`
      };
    }).filter(option => !option.hide);
  }

  allProductUserPermissions() {
    return this.memberOptions.every((option) => this.permission.getUsersControlPermissionName(option.name));
  }


  ngAfterViewChecked(): void {
    this.showTeamIndex = this.resize('team');
    if(this.disableAll && this.totalSurvey){
      this.resize('survey');
      this.showSurveyIndex = this.totalSurvey;
    }
    else{
      this.showSurveyIndex = this.resize('survey');
    }

    this.cdr.detectChanges();
  }

  titleChange(event: any) {
    this.email = event;
    this.xrefEmail = this.email.includes('@xref.com');
    if (this.errors[0].enabled) {
      this.validateEmail();
      setTimeout(() => {
        this.inputElement?.nativeElement?.childNodes[0]?.focus();
      }, 0);

    }
    this.clicked = false;
    this.validate();
  }
  checkedChange(role) {
    if (
      this.selectedRole == 'support' &&
      this.xrefEmail &&
      !this.isValid
    ) {
      this.xrefEmail = this.email.includes('@xref.com');
    }
    if (role == 'Member' && this.selectedRole != role) {
      this.memberOptions = this.memberOptions.map((value) => ({
        ...value,
        selected: 'None',
      }));
      this.selectedSurveys = [];
      this.showSurveyIndex = 0;
      this.disableAll = false;
      this.totalSurvey = 0;
    }
    this.selectedRole = role;
    this.clicked = false;
    this.validate();
  }

  dropDownOptionSelected(event, option) {
    if (event.value === 'None') {
      this.selectedSurveys = this.selectedSurveys.filter(value => !value?.survey_type?.toLowerCase().includes(option.filter_key))
    }
    option.selected = event.value;
    option.key = event.key;
    const originalOption = this.memberOptions.find(opt => opt.id === option.id);
    if (originalOption) {
      originalOption.selected = event.value;
      originalOption.key = event.key;
    }
    this.clicked = false;
    this.validate();
  }
  closeModal() {
    this.modalRef.hide();
  }
  save() {
    this.clicked = true;
    this.message = 'success';
    this.saveClick.emit(this.message)
  }

  resize(type: string) {
    let index = 0;
    const container: any = document.querySelector(`#${type}-container`);
    const containerItems = container?.querySelectorAll(`.${type}-item`);
    const containerWidth = container?.offsetWidth;
    let totalWidth = 0;

    containerItems?.forEach((check) => {
      check.style.display = 'flex';
      totalWidth += check.offsetWidth + 8;
      if (totalWidth > containerWidth) {
        check.style.display = 'none';
        index++;
      }
    });
    return index;
  }

  showTeam() {
    const selectedTeamsObject = {};
    this.selectedTeams.forEach((team) => {
      selectedTeamsObject[team.id] = team;
    });
    const initialState = {
      selectedTeams: selectedTeamsObject,
      pagination: { total: this.teams.length, rowsPerView: 20, currentPage: 1 },
      ...(this.cloneData?.first_name && { user: this.cloneData }),
      ...(this.cloneData?.email && { invitee: this.cloneData }),
      newUser: true,
    };
    const backdrop = this.renderer.createElement('div');
    this.renderer.addClass(backdrop, 'modal-backdrop');
    this.renderer.addClass(backdrop, 'fade');
    this.renderer.addClass(backdrop, 'show');
    this.renderer.setStyle(backdrop, 'z-index', '1050');
    this.renderer.appendChild(document.body, backdrop);
    this.model = this.modalService.show(ManageTeamsComponent, {
      class: 'modal-dialog-centered xl-popup',
      initialState,
    });
    this.model.onHide.subscribe(() => {
      this.renderer.removeChild(document.body, backdrop);
      if(this.model.content.message === 'confirm') {
        this.selectedTeams = Object.keys(this.model.content.selectedTeams).map(
          (key) => this.model.content.selectedTeams[key]
        );
        this.showTeamIndex = this.resize('team');
        this.cdr.detectChanges();
        this.validate();
        this.clicked = false;
      }
    });
  }

  showSurveys() {
    if (!this.selectedRole) return;
    const selectedOptions = this.memberOptions.filter((option) => option.selected != 'None');
    const newUserProducts = this.selectedRole === 'Member'
      ? (selectedOptions.length ? selectedOptions : [{ filter_key: 'None' }])
      : this.memberOptions;

    const initialState = {
      user: this.cloneData,
      surveysStates: this.selectedSurveys,
      newUser: true,
      userRole: this.selectedRole,
      newUserProducts: newUserProducts,
      cloned: this.cloned,
    };
    const backdrop = this.renderer.createElement('div');
    this.renderer.addClass(backdrop, 'modal-backdrop');
    this.renderer.addClass(backdrop, 'fade');
    this.renderer.addClass(backdrop, 'show');
    this.renderer.setStyle(backdrop, 'z-index', '1050');
    this.renderer.appendChild(document.body, backdrop);
    const model: any = this.modalService.show(
      ManageSurveyPermissionsModalComponent,
      {
        class: 'modal-dialog-centered xl-popup',
        initialState,
      }
    );
    model.onHide.subscribe(() => {
      this.orgUserService.updateData({});
      this.renderer.removeChild(document.body, backdrop);
      if (model.content.message == "savePermissionConfirm"){
        this.selectedSurveys = model.content.surveys.filter((survey) => (survey.is_permitted));
        if (model.content.selectAllButtonDisabled){
          this.totalSurvey = model.content.totalSurveys - 2;
          this.disableAll = model.content.selectAllButtonDisabled
        }
        else{
          this.showSurveyIndex = this.resize('survey');
        }
        this.cdr.detectChanges();
      }
    });
  }

  validate() {
    this.isValid = Boolean(
      this.email &&
        !this.errors[0].enabled &&
        (this.selectedRole === 'Owner' ||
          (this.selectedRole === 'support' && this.xrefEmail) ||
          (this.selectedRole === 'Member' &&
            this.memberOptions.some((role) => role.selected !== 'None'))) &&
        this.selectedTeams.length
    );
  }

  validateEmail() {
    this.errors[0] = {
      ...this.errors[0],
      enabled: !/^[a-zA-Z0-9'._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.email),
      msg: $localize`A valid business email address is required, please review and edit to proceed.`
    };

    this.validate();
  }

  openPermissionsPage() {
    window.open('account/permission-help', '_blank');
  }

  fetchTrustMarketplaceStatus() {
    this.trustMarketplaceStatusService.trustAdminStatus.subscribe(
        res => {
          if(res != undefined){
            const updatedOption = this.memberOptions.find(option => option.id === 4);
            if (updatedOption) {
              updatedOption.hide = !res;
            }
          }
        }, error => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      );
  }

  manageSurveyCheck() {
    return !this.selectedRole || !(this.selectedRole != 'Member' || (this.selectedRole == 'Member' && this.memberOptions?.some(option => option.selected != 'None')));
  }
}
